import * as React from "react";
import { ReactElement } from "react";
import * as Messages from "../../../../Messages";
import { toolEmail } from "../../../../settings";
import { useVinaJobDesiredRunContext } from "../../context/vina-job-desired-run-context";
import { useResultsContext } from "../../context/results-context";
import { EmailLink } from "@loschmidt/commons";
import { useJobContext } from "../../context/job-context";

export function VinaJobCheckedContainer({children}: {children?: ReactElement }) {

  const {
    allowed,
    unscheduled,
    failed,
    done,
  } = useVinaJobDesiredRunContext();

  const {backendResultsFetchState} = useJobContext();

  const {results} = useResultsContext();
  const inhibitors = results.inhibitors;

  if (allowed === false) {
    return <div className="ll-section-spinner">
      {Messages.warnIcon}
      <span>Virtual screening of inhibitors is not allowed for this protein or for this particular position.</span>
    </div>
  }

  if (failed) {
    return <div className="ll-section-spinner">
      {Messages.warnIcon}
      <span>Virtual screening of inhibitors failed. Please report this issue to <EmailLink email={toolEmail}/>.</span>
    </div>
  }

  if (done) {
    if (inhibitors && inhibitors.length > 0) {
      return children ?? null;
    } else if (backendResultsFetchState.fetching) {
      return (
        <div className="ll-section-spinner">
          {Messages.spinnerIcon}
          <span>Loading results...</span>
        </div>
      )
    } else {
      return <div className="ll-section-spinner">
        {Messages.warnIcon}
        <span>Virtual screening of inhibitors didn't produce any results. If the analyzed position has structural information, please report this issue to <EmailLink email={toolEmail}/>.</span>
      </div>
    }
  }

  if (unscheduled) {
    return (
      <div className="ll-section-spinner">
        {Messages.infoIcon}
        <span>To schedule virtual screening of inhibitors, use the "Analyze inhibitors" switch in the "Job information" section.</span>
      </div>
    )
  }

  return (
    <div className="ll-section-spinner">
      {Messages.spinnerIcon}
      <span>This calculation is still on-going.</span>
    </div>
  )

}